export function replaceSymbols(inputString: string, symbolsToReplace: string, replaceTo: string): string {
  const symbolsSet = new Set(symbolsToReplace);

  let result = '';
  for (const char of inputString) {
    if (symbolsSet.has(char)) {
      result += replaceTo;
    } else {
      result += char;
    }
  }

  return result;
}
